export function scrollToElement(selector) {
    document.querySelector(selector)?.scrollIntoView({behavior: 'instant', block: 'nearest', inline: 'nearest'});
}

export function scrollToElementSmooth(selector) {
    document.querySelector(selector)?.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'});
}
